import http from '../api/http';
import { PaginatedResponse } from '../types/common';

export interface ListParams {
  page?: number;
  page_size?: number;
  ordering?: string;
  search?: string;
  [key: string]: number | string | boolean | undefined;
}

export interface CrudService<T> {
  list: (params?: ListParams) => Promise<PaginatedResponse<T>>;
  retrieve: (id: number | string) => Promise<T>;
  create: (payload: Partial<T>) => Promise<T>;
  update: (id: number | string, payload: Partial<T>) => Promise<T>;
  partialUpdate: (id: number | string, payload: Partial<T>) => Promise<T>;
  remove: (id: number | string) => Promise<void>;
}

const ensureTrailingSlash = (endpoint: string): string =>
  endpoint.endsWith('/') ? endpoint : `${endpoint}/`;

export const createCrudService = <T>(endpoint: string): CrudService<T> => {
  const base = ensureTrailingSlash(endpoint);

  return {
    list: (params) => {
      console.log('🔍 [CRUD] LIST REQUEST:', {
        endpoint: base,
        params: params,
        fullUrl: params ? `${base}?${new URLSearchParams(params as any).toString()}` : base
      });
      return http.get<PaginatedResponse<T>>(base, { params }).then((res) => {
        console.log('✅ [CRUD] LIST RESPONSE:', {
          endpoint: base,
          status: res.status,
          count: res.data.count,
          next: res.data.next,
          previous: res.data.previous,
          results_length: res.data.results.length
        });
        return res.data;
      });
    },
    retrieve: (id) => http.get<T>(`${base}${id}/`).then((res) => res.data),
    create: (payload) => {
      console.log(`🏭 [CrudService] CREATE em: ${base}`);
      console.log("📦 Payload:", payload);
      return http.post<T>(base, payload).then((res) => res.data);
    },
    update: (id, payload) => {
      console.log(`🏭 [CrudService] UPDATE em: ${base}${id}/`);
      console.log("📦 Payload:", payload);
      return http.put<T>(`${base}${id}/`, payload).then((res) => res.data);
    },
    partialUpdate: (id, payload) => {
      console.log(`🏭 [CrudService] PARTIAL UPDATE em: ${base}${id}/`);
      console.log("📦 Payload:", payload);
      return http.patch<T>(`${base}${id}/`, payload).then((res) => res.data);
    },
    remove: (id) => http.delete<void>(`${base}${id}/`).then(() => undefined),
  };
};
